// AdminDataListItem.js
import { Dropdown } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import canna42 from "../assets/imgPlaceholder.png";
import styles from "../styles/adminDataListItem.module.css"; // Update CSS as needed
import { FormatInstance } from "../utils/formatClass";

const getNestedProperty = (obj: any, path: any) =>
  path.split(".").reduce((acc: any, part: any) => {
    console.log(`acc, ${acc}, part: ${part}, whole: ${acc[part]}`);
    if (part === "endDate") {
      console.log(`date be ${FormatInstance.formatCalendarDate(acc[part])}`);
      return FormatInstance.formatMDYDate(acc[part]);
    }
    return acc && acc[part];
  }, obj);

const AdminDataListItem = ({
  item,
  columns,
  actions,
  onItemSelect,
}: {
  item: any;
  columns: any[];
  actions: any[];
  onItemSelect: any;
}) => {
  const renderCellContent = (col: any) => {
    if (col.propName.includes(".")) {
      // Check if propName includes a nested path
      return getNestedProperty(item, col.propName);
    } else if ((col.propName === "name" || col.propName === "username") && item.avatarUrl) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={item.avatarUrl}
            onError={(e) => (e.currentTarget.src = canna42)}
            alt={item.name}
            style={{
              width: "50px",
              height: "50px",
              marginRight: "10px",
              borderRadius: 10,
            }}
          />
          {item[col.propName]}
        </div>
      );
    } else {
      return item[col.propName];
    }
  };

  return (
    <tr>
      {columns.map((col) => (
        <td onClick={() => onItemSelect(item)} key={col.propName} className="align-middle">
          {renderCellContent(col)}
        </td>
      ))}
      <td className={`${styles.actionsCell} align-middle`}>
        <Dropdown>
          <Dropdown.Toggle as={BsThreeDotsVertical} />
          <Dropdown.Menu>
            {actions.map((action) => (
              <Dropdown.Item key={action.name} onClick={() => action.method(item)}>
                {action.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </td>
      <td className="text-white">yot</td>
    </tr>
  );
};

export default AdminDataListItem;
